import React, { useEffect, useState, }  from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { GetUrl, GetMaintenanceUrl, CTicksToDateString } from '../Utility.js';
import { useNavigate } from 'react-router-dom';

function WriteModalType({ isOpen, onClose}) {
    const state = useSelector((state)=>state);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [First, setFirst] = useState(true);

    const Close = () =>{
        onClose();
        setFirst(true);
    }
  
    // 제목과 내용 글자 수 체크
    const handleTitleChange = (event) => {
      if (event.target.value.length <= 25) {
        setTitle(event.target.value);
      }
    };
  
    const handleContentChange = (event) => {
      if (event.target.value.length <= 500) {
        setContent(event.target.value);
      }
    };
  
    // 글자 수 표시
    const getTitleCharCount = () => {
      return `${title.length}/25`;
    };
  
    const getContentCharCount = () => {
      return `${content.length}/500`;
    };

    const RequestSummit = async () => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            if(title === "")
            {
                alert('제목을 입력 해 주세요');  
                return;
            }

            if(content === "")
            {
                alert('내용을 입력 해 주세요요');
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            } 
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'RegisterQA/RegisterQA', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, title:title, text:content}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    alert('1:1문의 등록 완료');  
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);
    
                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
            dispatch({type:'UpdateQARefresh', Refresh:true});
            Close();
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };    

    if (!isOpen) return null;

    if(First === true)
    {
        setFirst(false);
        setTitle('');
        setContent('');
    }

    return (
        <div className="write-modal-overlay" onClick={Close}>
                <div class="write-modal-overlay-container" onClick={(e) => e.stopPropagation()}>
                    <div class="write-modal-overlay-header">1:1문의 
                        <button class="close-btn" onClick={Close}>닫기</button>
                    </div>
                    <div class="write-modal-overlay-input-group">
                        <label for="title">제목</label>
                        <input 
                            type="text" 
                            id="title" 
                            maxlength="25" 
                            placeholder="제목을 입력하세요 (최대 25자)" 
                            value={title}
                            onChange={handleTitleChange}></input>
                        <div id="title-char-count" class="write-modal-overlay-char-count">{getTitleCharCount}</div>
                    </div>
                    <div class="write-modal-overlay-input-group">
                        <label for="content">내용</label>
                        <textarea 
                            id="content" 
                            maxlength="500" 
                            placeholder="내용을 입력하세요 (최대 500자)" 
                            value={content}
                            onChange={handleContentChange}>
                            </textarea>
                        <div id="content-char-count" class="write-modal-overlay-char-count">{getContentCharCount}</div>
                    </div>
                    <button class="write-modal-overlay-submit-btn" onClick={RequestSummit}>제출</button>
            </div>
        </div>
    );
}

export default WriteModalType;